import React, { useState } from 'react';
import { BookmarkIcon } from '@heroicons/react/24/outline';
import { BookmarkIcon as BookmarkSolidIcon } from '@heroicons/react/24/solid';
import { toast } from 'react-hot-toast';
import intranetApi from '../../services/intranetApi';

const PostBookmark = ({ 
  postId, 
  bookmarkCount = 0, 
  userBookmarked = false, 
  onToggleBookmark,
  showCount = true,
  size = 'md' // 'sm', 'md', 'lg'
}) => {
  const [isBookmarked, setIsBookmarked] = useState(userBookmarked);
  const [count, setCount] = useState(bookmarkCount);
  const [loading, setLoading] = useState(false);

  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-5 w-5',
    lg: 'h-6 w-6'
  };

  const handleToggleBookmark = async () => {
    if (loading) return;

    setLoading(true);
    const previousState = { isBookmarked, count };

    try {
      // Optimistic update
      setIsBookmarked(!isBookmarked);
      setCount(prev => isBookmarked ? prev - 1 : prev + 1);

      const response = await intranetApi.posts.toggleBookmark(postId);
      
      if (response.data.success) {
        // Update with server response
        setIsBookmarked(response.data.user_bookmarked);
        setCount(response.data.bookmark_count);
        
        // Call parent callback if provided
        if (onToggleBookmark) {
          onToggleBookmark(response.data.user_bookmarked, response.data.bookmark_count);
        }

        // Optional: Show toast feedback
        // toast.success(response.data.message);
      } else {
        throw new Error(response.data.error || 'Failed to toggle bookmark');
      }
    } catch (error) {
      // Revert optimistic update
      setIsBookmarked(previousState.isBookmarked);
      setCount(previousState.count);
      
      console.error('Error toggling bookmark:', error);
      toast.error(error.response?.data?.error || 'Failed to toggle bookmark');
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleToggleBookmark}
      disabled={loading}
      className={`flex items-center space-x-1 transition-colors duration-200 ${
        isBookmarked 
          ? 'text-yellow-600 hover:text-yellow-700' 
          : 'text-gray-400 hover:text-yellow-600'
      } ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
      title={isBookmarked ? 'Remove bookmark' : 'Bookmark this post'}
    >
      {isBookmarked ? (
        <BookmarkSolidIcon className={sizeClasses[size]} />
      ) : (
        <BookmarkIcon className={sizeClasses[size]} />
      )}
      {showCount && (
        <span className="text-sm font-medium">
          {count}
        </span>
      )}
    </button>
  );
};

export default PostBookmark; 